import { render } from "./Confirm.vue?vue&type=template&id=b3462d64&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=b3462d64&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3462d64"]])

export default __exports__